import { IonButton, IonIcon } from "@ionic/react";
import { backspaceOutline, chevronBackOutline } from "ionicons/icons";
import { useHistory } from "react-router-dom";

const BackButton = ({bgKolor}) => {
  const history = useHistory();

  const handleBack = () => {
    history.goBack();
  };

  return (
    <button
      onClick={handleBack}
      className="backbtn flex items-center justify-center text-white-600 hover:text-green-700 focus:text-green-700 font-medium py-2 px-4 transition duration-200 border-none"
      style={{ backgroundColor: bgKolor, color:"#f9f9f8", cursor: "pointer" }}
    >
      <IonIcon icon={chevronBackOutline} className="mr-2 text-lg" style={{color: "#f9f9f8", pointerEvents: "none"}} />
      Back
    </button>
  );
};

export default BackButton;
